/** @file poseCommand: the one command that writes some nodes' keys at a frame, keeping the key's others. */
import { keyAt } from '@zilo/pose3d-commands/clip/keyAt';
import type { Command } from '@zilo/pose3d-commands/types/command';
import type { Clip, NodeKey } from '@zilo/pose3d-format/types/clip';

/**
 * `clip.setPose` with the frame's existing nodes merged under `nodes` and its `ease` kept (setPose replaces the
 * key's nodes); a key that carries a key-level `hold` goes through `clip.setKeys` `mergeNodes`, which keeps it.
 */
export function poseCommand(clipName: string, clip: Pick<Clip, 'keys'>, frame: number, nodes: Record<string, NodeKey>): Command {
  const key = keyAt(clip, frame);
  if (key?.hold !== undefined) {
    return { name: 'clip.setKeys', input: { clip: clipName, keys: [{ frame, nodes }], merge: 'mergeNodes' } };
  }
  const merged = { ...(key?.nodes ?? {}), ...nodes };
  return { name: 'clip.setPose', input: { clip: clipName, frame, nodes: merged, ...(key?.ease === undefined ? {} : { ease: key.ease }) } };
}
